import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	notStarted: {
		id: 'backlog.card-list.estimations.not-started',
		defaultMessage: 'To Do',
		description:
			'Issue count, original time estimate or total story points that are not started yet.',
	},
	inProgress: {
		id: 'backlog.card-list.estimations.in-progress',
		defaultMessage: 'In Progress',
		description: 'Issue count, original time estimate or total story points that are in progress.',
	},
	done: {
		id: 'backlog.card-list.estimations.done',
		defaultMessage: 'Done',
		description: 'Issue count, original time estimate or total story points that are done.',
	},
	notStartedV2: {
		id: 'backlog.card-list.estimations.not-started-v-2',
		defaultMessage: 'Not started',
		description:
			'Issue count, original time estimate or total story points that are not started yet.',
	},
	inProgressV2: {
		id: 'backlog.card-list.estimations.in-progress-v-2',
		defaultMessage: 'In progress',
		description: 'Issue count, original time estimate or total story points that are in progress.',
	},
	completed: {
		id: 'backlog.card-list.estimations.completed',
		defaultMessage: 'Completed',
		description: 'Issue count, original time estimate or total story points that are done.',
	},
	tooltip: {
		id: 'backlog.card-list.estimations.tooltip',
		defaultMessage: '{count} of {total} ({estimationName})',
		description: 'Message to follow the status in the tooltip. e.g. Done: 4 or 10 (story points)',
	},
	storyPoints: {
		id: 'backlog.card-list.estimations.story-points',
		defaultMessage: 'Story points',
		description:
			'Story points as the unit to follow the status in tooltip, e.g. Done - Story points',
	},
	originalEstimate: {
		id: 'backlog.card-list.estimations.original-estimate',
		defaultMessage: 'Original estimate',
		description:
			'Original estimate (time estimation) as the unit to follow the status in tooltip, e.g. Done - Original estimate',
	},
	issueCount: {
		id: 'backlog.card-list.estimations.issue-count',
		defaultMessage: 'Issue count',
		description:
			'Issue count as the unit to follow the status in tooltip, e.g. In progress - Issue count',
	},
	leftmostColumn: {
		id: 'backlog.card-list.estimations.leftmost-column',
		defaultMessage: 'leftmost column',
		description: 'The leftmost column of a board',
	},
	rightmostColumn: {
		id: 'backlog.card-list.estimations.rightmost-column',
		defaultMessage: 'rightmost column',
		description: 'The rightmost column of a board',
	},
	issueCountIssueTermRefresh: {
		id: 'backlog.card-list.estimations.issue-count-issue-term-refresh',
		defaultMessage: 'Work item count',
		description:
			'Issue count as the unit to follow the status in tooltip, e.g. In progress - Issue count',
	},
});
export type Message = (typeof messages)[keyof typeof messages];
export default messages;
